<template>
  <div id="journalAccount">
    <div class="secondWrap">
      <div v-for="item of dataList" :key="item.marketId" :class="marketId == item.marketId?'activeSecond':''" @click="handleSelect(item.marketId)">
        {{ item.accountName }}流水
      </div>
    </div>
    <div id="tablePage">
      <el-table
        ref="tableData"
        :data="tableData"
        :height="tableHeight"
        style="width: 100%">
        <template slot="empty">
          <div class="no-datas1">
            <div
              class="no-data-img"
              style="margin: 100px auto 0px; width: 120px; height: 200px;"
            >
              <img
                src="../../../assets/images/no_data.png"
                alt=""
                style="width: 100%;"
              >
              <span>暂无数据</span>
            </div>
          </div>
        </template>
        <el-table-column align="center" prop="flowId" label="流水号">
        </el-table-column>
        <el-table-column align="center" prop="bizName" label="类型">
        </el-table-column>
        <el-table-column align="center" prop="amount" label="发生额">
          <template slot-scope="scope">
            <span :style="{color: scope.row.amountColor}">{{ scope.row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="balance" label="资金余额">
        </el-table-column>
        <el-table-column prop="occurTime" label="发生时间" width="90">
          <template slot-scope="scope">
            {{ scope.row.occurTime | dateFormate }}
          </template>
        </el-table-column>
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            class="paginationPage"
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
/*global protocol http util */
// import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      tableHeight: 0,
      marketId: 0,
      dataList: window.g.APP_market,
      activeIndex: '0',
      tableData: [],
      pageData: {
        total: 0,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      }
    }
  },
  mounted() {
    this.queryMyIntegralDetail(this.marketId)
  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },
  methods: {
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.queryMyIntegralDetail(this.marketId)
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.queryMyIntegralDetail(this.marketId)
    },
    queryMyIntegralDetail() {
      protocol.param_queryFirmAccountFundsFlow.param.page = this.pageData.currentPage - 1
      protocol.param_queryFirmAccountFundsFlow.param.size = this.pageData.pageSize
      protocol.param_queryFirmAccountFundsFlow.param.symbolId = 1
      protocol.param_queryFirmAccountFundsFlow.param.sort = [
        {
          direction: 'DESC', // "//DESC或ASC",
          property: 'flowId' // "//排序属性"
        }]
      http.postFrontChange(protocol.param_queryFirmAccountFundsFlow, Number(this.marketId)).then(response => {
        const { code, message, value } = response.data
        if (code == '0') {
          if (value && code == '0') {
            this.pageData.total = value.totalElements
            const arr = value.content
            // 处理千分位分隔符，和小数点后两位
            arr.forEach(element => {
              element.amountColor = Number(element.amount) > 0 ? '#D94066' : '#41B37D'
              element.amount = util.formatNum(element.amount)
              element.balance = util.formatNum(element.balance)
            })
            this.tableData = arr
          }
        } else {
          this.$message(message)
        }
      })
    },
    handleSelect(e) {
      this.marketId = String(e)
      this.queryMyIntegralDetail()
    }
  }
}
</script>